import { render, staticRenderFns } from "./CallCenterOrdersDashboard.vue?vue&type=template&id=737a1a40&scoped=true&"
import script from "./CallCenterOrdersDashboard.vue?vue&type=script&lang=js&"
export * from "./CallCenterOrdersDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CallCenterOrdersDashboard.vue?vue&type=style&index=0&id=737a1a40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737a1a40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
